import React from 'react';
import { ReactComponent as CustomIcon } from 'assets/icons/default-layout-icon.svg';

const CustomLayoutIcon = () => {
  return <CustomIcon />;
};

export default CustomLayoutIcon;
